import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { applyThemeToDocument } from "../../salon-admin/utils/theme";
import { confirmAndLogout, PORTAL_EMAIL_KEY } from "../utils/auth";
import nyafazLogo from "../../salon-admin/assets/nyafazlogo.png";

const PortalHeadHeader = ({ showLogo, onToggleSidebar, sidebarOpen }) => {
  const navigate = useNavigate();
  const email = localStorage.getItem(PORTAL_EMAIL_KEY) || "Nyafaz head";

  useEffect(() => {
    applyThemeToDocument("light");
  }, []);

  return (
    <header className="header-shell w-full">
      <div className="header-shell__inner header-shell__inner--integrated flex min-h-[3.25rem] w-full flex-wrap items-center justify-end gap-2 px-1 py-1 md:min-h-[3.5rem] md:gap-3 lg:h-14 lg:flex-nowrap lg:px-2">
        <div className="header-shell__left flex min-w-0 flex-1 items-center gap-3 lg:hidden">
          {typeof onToggleSidebar === "function" ? (
            <button
              type="button"
              className="header-menu-btn"
              aria-label={sidebarOpen ? "Close menu" : "Open menu"}
              aria-expanded={sidebarOpen}
              onClick={onToggleSidebar}
            >
              {sidebarOpen ? <FiX size={18} /> : <FiMenu size={18} />}
            </button>
          ) : null}
          {showLogo ? (
            <img src={nyafazLogo} alt="Nyafaz" className="h-8 object-contain md:h-9" />
          ) : null}
        </div>

        <div className="header-shell__actions flex w-full min-w-0 flex-wrap items-center justify-end gap-2 sm:gap-2.5 md:w-auto md:flex-nowrap lg:ml-auto">
          <span className="hidden md:inline text-sm theme-body truncate max-w-[200px]">{email}</span>
          <button
            type="button"
            className="portal-btn portal-btn--ghost text-sm"
            onClick={() => confirmAndLogout(navigate)}
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default PortalHeadHeader;
